(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
if (!customElements.get('woenix-related-slider')) {
  customElements.define('woenix-related-slider', class extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => {
        if (!this.isConnected || this.initialized) return;
        const slider = this.querySelector('ul');
        const buttons = Array.from(this.querySelectorAll('[data-direction]'));
        if (!slider || buttons.length !== 2) return;
        this.initialized = true;
        const update = () => {
          const position = Math.abs(slider.scrollLeft);
          buttons[0].disabled = position <= 2;
          buttons[1].disabled = position >= slider.scrollWidth - slider.clientWidth - 2;
        };
        buttons.forEach(button => button.addEventListener('click', () => {
          const card = slider.firstElementChild;
          if (!card) return;
          const gap = parseFloat(getComputedStyle(slider).columnGap) || 0;
          const direction = getComputedStyle(slider).direction === 'rtl' ? -1 : 1;
          slider.scrollBy({left:(card.getBoundingClientRect().width + gap) * Number(button.dataset.direction) * direction,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
        }));
        slider.addEventListener('scroll', update, {passive:true});
        this.observer = new ResizeObserver(update);
        this.observer.observe(slider);
        update();
      });
    }
    disconnectedCallback() { this.observer?.disconnect(); this.initialized = false; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["woenix-brand-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('woenix-brand-products')) {
  customElements.define('woenix-brand-products', class extends HTMLElement {
    connectedCallback() {
      if (this.loaded) return;
      this.loaded = true;
      this.loadProducts();
    }
    disconnectedCallback() { this.resizeObserver?.disconnect(); }
    async loadProducts() {
      try {
        const quote = value => '"' + value.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
        const url = new URL(this.dataset.search, location.origin);
        url.searchParams.set('q', 'vendor:' + quote(this.dataset.brand) + ' AND product_type:' + quote(this.dataset.type));
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[unavailable_products]', 'hide');
        url.searchParams.set('options[prefix]', 'none');
        url.searchParams.set('view', 'woenix-brand');
        const read = async page => {
          url.searchParams.set('page', page);
          const response = await fetch(url, {credentials:'same-origin'});
          if (!response.ok) throw new Error('Product request failed');
          return new DOMParser().parseFromString(await response.text(), 'text/html');
        };
        const first = await read(1);
        const pages = Number(first.querySelector('[data-brand-results]')?.dataset.pages || 1);
        const documents = [first];
        for (let page = 2; page <= pages; page++) documents.push(await read(page));
        const seen = new Set();
        const cards = documents.flatMap(doc => Array.from(doc.querySelectorAll('[data-brand-card]'))).filter(card => {
          const id = card.dataset.product;
          if (id === this.dataset.product || card.dataset.brand !== this.dataset.brand || card.dataset.type !== this.dataset.type || seen.has(id)) return false;
          seen.add(id);
          return true;
        });
        for (let i = cards.length - 1; i > 0; i--) {
          const random = new Uint32Array(1);
          crypto.getRandomValues(random);
          const j = Math.floor(random[0] / 4294967296 * (i + 1));
          [cards[i], cards[j]] = [cards[j], cards[i]];
        }
        const selected = cards.slice(0, Number(this.dataset.limit));
        if (!selected.length || !this.isConnected) return;
        this.querySelector('ul').replaceChildren(...selected);
        this.hidden = false;
        const slider = this.querySelector('ul');
        const buttons = Array.from(this.querySelectorAll('[data-direction]'));
        const updateControls = () => {
          const atStart = slider.scrollLeft <= 2;
          const atEnd = slider.scrollLeft >= slider.scrollWidth - slider.clientWidth - 2;
          buttons[0].disabled = atStart;
          buttons[1].disabled = atEnd;
        };
        buttons.forEach(button => button.addEventListener('click', () => {
          const card = slider.firstElementChild;
          const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(slider).columnGap || 0);
          slider.scrollBy({left:step * Number(button.dataset.direction),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
        }));
        slider.addEventListener('scroll', updateControls, {passive:true});
        this.resizeObserver = new ResizeObserver(updateControls);
        this.resizeObserver.observe(slider);
        updateControls();
      } catch (error) {
        this.hidden = true;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
